import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box
} from '@mui/material';
import './TablaHorario.css';

function TablaHorario({ horarioData }) {
  if (!horarioData || !horarioData.horarios?.length) {
    return <Typography variant="body2">No se encontró horario asignado.</Typography>;
  }

  const diasAgrupados = {};
  let totalSemana = 0;

  horarioData.horarios[0].dias.forEach(({ dia_semana, hora_entrada, hora_salida, horas_diarias }) => {
    if (!diasAgrupados[dia_semana]) {
      diasAgrupados[dia_semana] = {
        tramos: [],
        totalDia: 0
      };
    }
    diasAgrupados[dia_semana].tramos.push(`${hora_entrada} a ${hora_salida}`);
    diasAgrupados[dia_semana].totalDia += horas_diarias;
    totalSemana += horas_diarias;
  });

  return (
    <Paper elevation={3} className="tabla-horario-container">
     <Box className="tabla-horario-header1">
  <span id='titulo-tabla-horario'>Horario Semanal</span>
  <span id='titulo-tabla-horario2'>{totalSemana} H</span>
</Box>


      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow className="tabla-horario-header">
              <TableCell>Día</TableCell>
              <TableCell>Horas</TableCell>
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
  {Object.entries(diasAgrupados).map(([dia, data]) => (
    <TableRow key={dia} className="tabla-horario-row">
      <TableCell id="dato-tabla-horario">{dia}</TableCell>
      <TableCell id="dato-tabla-horario">{data.tramos.join(', ')}</TableCell>
      <TableCell align="right" id="dato-tabla-horario">{data.totalDia}h</TableCell>
    </TableRow>
  ))}
</TableBody>

        </Table>
      </TableContainer>
    </Paper>
  );
}

export default TablaHorario;
